import React, { useState, useEffect } from "react";
import "./App.css";
import Calendar from "./components/Calendar";
import Finance from "./components/Finance";
import Reminders from "./components/Reminders";
import Login from "./components/Login";
import { useAuth } from "./context/AuthContext";
import "./design.css";
const MAIN = [["calendar", "Календарь"], ["finance", "Финансы"], ["reminders", "Напоминания"]];
const readTab = () => MAIN.some(([id]) => id === window.location.hash.slice(1)) ? window.location.hash.slice(1) : "calendar";
export default function App() {
  const { user, loading, logout } = useAuth();
  const [active, setActive] = useState(readTab);
  useEffect(() => { const change = () => setActive(readTab()); window.addEventListener("hashchange", change); return () => window.removeEventListener("hashchange", change); }, []);
  if (loading) return <div className="App-loading">Загрузка…</div>;
  if (!user) return <Login />;
  return <div className="App Shell Shell--compact">
    <header className="Shell-topbar">
      <span className="Shell-wordmark" aria-label="Khagronflow">K</span>
      <nav className="Shell-topnav" aria-label="Основные разделы">{MAIN.map(([id, title]) => <button key={id} className={`Shell-link ${active === id ? "is-active" : ""}`} aria-current={active === id ? "page" : undefined} onClick={() => { window.location.hash = id; setActive(id); }}>{title}</button>)}</nav>
      <details className="Shell-account"><summary aria-label="Профиль">•••</summary><div><strong>{user.first_name || user.username}</strong><button className="Shell-secondary" onClick={logout}>Выйти</button></div></details>
    </header>
    <main key={user.id} className="App-content Shell-main">
      <div className="App-tab-pane" hidden={active !== "calendar"}><Calendar /></div>
      <div className="App-tab-pane" hidden={active !== "finance"}><Finance /></div>
      <div className="App-tab-pane" hidden={active !== "reminders"}><Reminders /></div>
    </main>
  </div>;
}
